export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "de", name: "German" },
  { code: "fr", name: "French" },
  { code: "es", name: "Spanish" },
  { code: "it", name: "Italian" },
  { code: "nl", name: "Dutch" },
  { code: "pt", name: "Portuguese" },
  { code: "ru", name: "Russian" },
  { code: "uk", name: "Ukrainian" },
  { code: "pl", name: "Polish" },
  { code: "cs", name: "Czech" },
  { code: "sk", name: "Slovak" },
  { code: "hu", name: "Hungarian" },
  { code: "ro", name: "Romanian" },
  { code: "bg", name: "Bulgarian" },
  { code: "hr", name: "Croatian" },
  { code: "sl", name: "Slovenian" },
  { code: "sr", name: "Serbian" },
  { code: "zh", name: "Chinese" },
  { code: "ja", name: "Japanese" },
  { code: "ko", name: "Korean" },
  { code: "el", name: "Greek" },
  { code: "az", name: "Azerbaijani" },
  { code: "ar", name: "Arabic" },
  { code: "ms", name: "Malay" },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

export const DEFAULT_CATALOGUE_LANGUAGES: LanguageCode[] = ["en"];
export const MAX_CATALOGUE_LANGUAGES = 5;

const LANGUAGE_NAMES = Object.fromEntries(
  SUPPORTED_LANGUAGES.map(({ code, name }) => [code, name])
) as Record<LanguageCode, string>;

export function languageName(code: LanguageCode): string {
  return LANGUAGE_NAMES[code];
}

export function canonicalLanguages(languages: readonly LanguageCode[]): LanguageCode[] {
  const selected = new Set<LanguageCode>(["en", ...languages]);
  return SUPPORTED_LANGUAGES.filter(({ code }) => selected.has(code))
    .slice(0, MAX_CATALOGUE_LANGUAGES)
    .map(({ code }) => code);
}
